// src/components/FrontId.js
import React, { useEffect, useRef } from "react";
import incode from "../services/incode";

const FrontId = ({ session, onSuccess, onError }) => {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) return;

    incode.renderCamera("front", containerRef.current, {
      onSuccess,
      onError,
      token: session,
      numberOfTries: 3,
      showTutorial: true,
      showCustomCameraPermissionScreen: true,
      showDoublePermissionsRequest: true,
    });

    isMounted.current = true;
  }, [onSuccess, onError, session]);

  return <div ref={containerRef}></div>;
};

export default FrontId;
